import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/RefreshProfileAudience.graphql';
import { Mutation, MutationrefreshProfileAudienceArgs } from '../../__generated__/globalTypes';

export const useRefreshProfileAudienceMutation = (
  options?: MutationHookOptions<Mutation, MutationrefreshProfileAudienceArgs>
) => {
  const [callRefreshProfileAudience, result] = useMutation<Mutation, MutationrefreshProfileAudienceArgs>(
    MUTATION,
    options
  );

  return { callRefreshProfileAudience, ...result };
};

export type RefreshProfileAudienceMutationFunction = Mutation['refreshProfileAudience'];
